import useSessionStore from '@pinia/session';

export default ({ token, expiresAt }: { token?: string; expiresAt?: string }) => {
  const sessionStore = useSessionStore();
  const handleExpiredSessions = async () => {
    // remove all stale sessions
    sessionStore.sessions = sessionStore.sessions.filter(
      (s) => s.expiresAt != null && s.expiresAt * 1000 > Date.now(),
    );
  };

  const handleImpersonation = async (): Promise<void> => {
    try {
      if (token != null && expiresAt != null) {
        // decode token
        const decodedToken = atob(token as string);
        // pass token to session store and init impersonation
        await sessionStore.addSession(decodedToken, expiresAt);
        return;
      }

      // here, we need to check, if we are already impersonating
      if (sessionStore.mainSession.id !== sessionStore.selectedSessionId) {
        // just init the session
        await sessionStore.initSession(sessionStore.selectedSessionId);
      }

      handleExpiredSessions();
    } catch (error) {
      // if something goes wrong, we need to restore to the main session
      sessionStore.switchSession(sessionStore.mainSession.id);
    }
  };

  return {
    handleImpersonation,
  };
};
